import React from 'react';
import Layout from "../../../components/Wrappers/Layout";
import CashLiftingFilter from './CashLiftingFilter';
import CashLiftingList from './CashLiftingList';

function BankCashLifting() {
  return (
	<Layout>
		<CashLiftingFilter />
		<CashLiftingList />
	</Layout>
  )
}

export default BankCashLifting